// extracted by mini-css-extract-plugin
module.exports = {"areaTable":"index-areaTable-Hs_D1","bar":"index-bar-ydseG","info":"index-info-3mepX"};